import { Moment } from 'moment';
import { Observable } from 'rxjs';
import { RuleEngineInput } from '@coin/shared/core/util-models';
import { Type } from '@angular/core';

export type LightWeightOperator = (typeof LIGHTWEIGHT_OPERATORS)[number];
export type LightWeightCondition = (typeof LIGHTWEIGHT_CONDITIONS)[number];
export type RuleValue = (string | boolean | Moment)[];
export interface LightweightRule {
  field: string;
  operator: LightWeightOperator;
  value: RuleValue;
}
export interface LightweightRuleSet {
  condition: LightWeightCondition;
  rules: (LightweightRule | LightweightRuleSet)[];
}
export type LightweightRuleEngine = {
  condition: LightWeightCondition;
  rules: Array<LightweightRule | LightweightRuleSet>;
  id?: string;
};

export interface RuleEngineComponentInput {
  getDefaultValue(): RuleValue;
  component: Type<unknown>;
}

export interface LightweightRuleEngineConfig {
  [field: string]: {
    operators: LightWeightOperator[];
    fieldValues$: Observable<string[]>;
    type: RuleEngineInput | RuleEngineComponentInput;
  };
}

export const LIGHTWEIGHT_OPERATORS = [
  'Equal',
  'NotEqual',
  'Contains',
  'NotContains',
  'StartsWith',
  'EndsWith',
  'Greater',
  'GreaterOrEqual',
  'Less',
  'LessOrEqual',
  'Empty',
  'NotEmpty',
  'NotStartsWith',
  'NotEndsWith'
] as const;
export const VALUELESS_OPERATORS = new Set<LightWeightOperator>(['NotEmpty', 'Empty']);
export const FREE_TEXT_OPERATORS = new Set<LightWeightOperator>([
  'StartsWith',
  'NotStartsWith',
  'NotEndsWith',
  'EndsWith',
  'Contains',
  'NotContains'
]);

export const LIGHTWEIGHT_CONDITIONS = ['Or', 'And'] as const;

export const CONDITION_LABELS: Record<LightWeightCondition, string> = { And: 'all', Or: 'any' };

export const TRANSLATE_PREFIX = 'general.rule-engine.keys.';

export const RULESET_MIN_LENGTH = 2;
